import { Subscription, SubscriptionStatus } from '@/shared/types/Billing';

import { isSubscriptionExpired } from './isSubscriptionExpired';

// unpaid/past_due are considered active if current_period_end is in the future
const ACTIVE_SUBSCRIPTION_STATUSES = new Set([
  SubscriptionStatus.Active,
  SubscriptionStatus.Incomplete,
  SubscriptionStatus.IncompleteExpired,
  SubscriptionStatus.PastDue,
  SubscriptionStatus.Trialing,
  SubscriptionStatus.Unpaid,
]);
export const isSubscriptionActive = (subscription: Subscription) => {
  return (
    ACTIVE_SUBSCRIPTION_STATUSES.has(subscription.status) &&
    !isSubscriptionExpired(subscription.current_period_end) &&
    !subscription?.payments_collection_paused
  );
};
